// extracted by mini-css-extract-plugin
export default {"App":"InfosInviteUser_App__73j9x","container":"InfosInviteUser_container__7eB6e"};